import { BookingStatus } from 'store/bookings/types';

/*
 * The My Bookings lists do not filter on the client: both tabs are server-paged (helix #11187), so
 * a row dropped here would be a hole in a page `total` had already counted.
 * Its own module rather than `useUpcomingBookings` because specs automock that hook, which replaces
 * every export -- a second module importing this predicate from there got `undefined` and threw.
 */
const CANCELLATION_STATUSES: Array<BookingStatus> = [BookingStatus.CANCELED, BookingStatus.LATE_CANCEL];
const REJECTION_STATUSES: Array<BookingStatus> = [BookingStatus.DENIED_AVAILABLE, BookingStatus.DENIED_UNAVAILABLE];

/** Whether the landing carousel hides a booking of this status. My Bookings goes by the `statuses`
 * on the request instead, and deliberately shows rejections and cancellations. */
export const isHiddenFromList = (status: BookingStatus, includeRejected: boolean): boolean =>
  CANCELLATION_STATUSES.includes(status) ||
  (!includeRejected && (REJECTION_STATUSES.includes(status) || status === BookingStatus.PAYMENT_CHALLENGE_CANCELED));

/** A constant rather than a literal per call site: the list and the page around it both ask whether
 * rejections count, and two spellings means an empty state drawn beside a list that has rows. */
export const MY_BOOKINGS_INCLUDE_REJECTED = true;
